var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditSolid = function SvgEditSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 4.031c-.766 0-1.516.297-2.094.875L13 14.781l-.219.219-.062.313-.688 3.5-.312 1.468 1.469-.312 3.5-.688.312-.062.219-.219 9.875-9.906A2.968 2.968 0 0 0 25 4.03m0 1.938c.234 0 .465.12.688.343.445.446.445.93 0 1.375L16 17.376l-1.719.344.344-1.719 9.688-9.687c.222-.223.453-.344.687-.344M4 8v20h20V14.813l-2 2V26H6V10h9.188l2-2Z"
  })));
};
export default SvgEditSolid;